document.addEventListener("DOMContentLoaded", function () {
    const dataDiv = document.getElementById('store-credit-data');
    if (!dataDiv) return;
    const rawValue = dataDiv.getAttribute('data-balance') || 'Rs. 0.00';
    const section = document.querySelector(
        '#customer_dashboard .cd_main_box .cd_main-content #cd_my-profile .cd_main-section-1.cd_main-section-2'
    );
    if (!section) return;
    const box = document.createElement('div');
    box.className = 'cd_box';
    box.id = 'store-credit-box';
    box.innerHTML = `
        <div class="cd_box-logo">
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="32" height="32" rx="6" fill="#e6f9f0"/>
            <text x="16" y="22" text-anchor="middle" font-size="16" font-weight="600" fill="#0f7a45" font-family="sans-serif">₹</text>
        </svg>
        <div class="cd_box-content">
            <p>Store credit</p>
            <p>${rawValue}</p>
        </div>
        </div>
    `;
    section.appendChild(box);
});